export const getStatusColor = (status) => {
  switch (status) {
    case "เสร็จสิ้น":
      return { label: "เสร็จสิ้น", color: "#2E7D32" };
    case "ใช้งานอยู่":
      return { label: "ใช้งานอยู่", color: "#2E7D32" };
    case "ดำเนินการ":
      return { label: "ดำเนินการ", color: "#D32F2F" };
    case "ใกล้หมดอายุ":
      return { label: "ใกล้หมดอายุ", color: "#F3B600" };
    case "หมดอายุ":
      return { label: "หมดอายุ", color: "#949494" };
    case "ไม่อนุมัติ":
      return { label: "ไม่อนุมัติ", color: "#D32F2F" };
    case "รอเอกสาร":
    case "เอกสารไม่ครบ":
      return { label: "เอกสารไม่ครบ", color: "#D32F2F" };
    case "รอตรวจสอบ":
      return { label: "รอตรวจสอบ", color: "#FD7E14" };
    case "ตรวจสอบ":
      return { label: "ตรวจสอบ", color: "#FD7E14" };
    case "รอชำระเงิน":
      return { label: "รอชำระเงิน", color: "#D32F2F" };
    case "ชำระแล้ว":
      return { label: "ชำระแล้ว", color: "#2E7D32" };
    case "ยกเลิก":
      return { label: "ยกเลิก", color: "#2E2E2E" };
    case "ยังไม่ชำระ":
      return { label: "ยังไม่ชำระ", color: "#D32F2F" };
    case "ค้างชำระ":
      return { label: "ค้างชำระ", color: "#D32F2F" };
    case "ขาย":
    case "sell":
      return { label: "ขาย", color: "#D32F2F" };
    case "ขายแล้ว":
      return { label: "ขายแล้ว", color: "#2E2E2E" };
    case "รอซ่อม/ปรับสภาพ":
      return { label: "รอซ่อม/ปรับสภาพ", color: "#D32F2F" };
    case "พร้อมขาย":
      return { label: "พร้อมขาย", color: "#2E7D32" };
    case "ซื้อ":
    case "buy":
    case "buy_car":
      return { label: "ซื้อ", color: "#9C27B0" };
    case "ฝากขาย":
    case "consignment":
    case "consignment_car":
      return { label: "ฝากขาย", color: "#0288D1" };
    case "ขายฝาก":
    case "pawn":
    case "pawn_car":
      return { label: "ขายฝาก", color: "#FD7E14" };
    case "หลุดจำนำ":
      return { label: "หลุดจำนำ", color: "#D32F2F" };
    case "ไถ่ถอน":
      return { label: "ไถ่ถอน", color: "#9C27B0" };
    default:
      return { label: "ปิดกิจการ", color: "#2E2E2E" };
  }
};
